/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The validator accepts the quote as is.
 * @export
 * @interface ValiderDemandeCommand
 */
export interface ValiderDemandeCommand {
    /**
     * Optional message to the broker.
     * @type {string}
     * @memberof ValiderDemandeCommand
     */
    message?: string | null;
    /**
     * Optional special clause (free text) added to the quote.
     * @type {string}
     * @memberof ValiderDemandeCommand
     */
    clauseParticuliere?: string | null;
}

/**
 * Check if a given object implements the ValiderDemandeCommand interface.
 */
export function instanceOfValiderDemandeCommand(value: object): value is ValiderDemandeCommand {
    return true;
}

export function ValiderDemandeCommandFromJSON(json: any): ValiderDemandeCommand {
    return ValiderDemandeCommandFromJSONTyped(json, false);
}

export function ValiderDemandeCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValiderDemandeCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'] == null ? undefined : json['message'],
        'clauseParticuliere': json['clauseParticuliere'] == null ? undefined : json['clauseParticuliere'],
    };
}

export function ValiderDemandeCommandToJSON(json: any): ValiderDemandeCommand {
    return ValiderDemandeCommandToJSONTyped(json, false);
}

export function ValiderDemandeCommandToJSONTyped(value?: ValiderDemandeCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'clauseParticuliere': value['clauseParticuliere'],
    };
}

